var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAgeRating7 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "7")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2496563,0 C19.7686292,0 21,1.23137084 21,2.75034375 L21,18.2496563 C21,19.7686292 19.7686292,21 18.2496563,21 L2.75034375,21 C1.23137084,21 0,19.7686292 0,18.2496563 L0,2.75034375 C0,1.23137084 1.23137084,0 2.75034375,0 L18.2496563,0 Z M18.2496563,1 L2.75034375,1 C1.83199,1 1.07882314,1.70724917 1.00580234,2.60678835 L1,2.75034375 L1,18.2496563 C1,19.16801 1.70724917,19.9211769 2.60678835,19.9941977 L2.75034375,20 L18.2496563,20 C19.16801,20 19.9211769,19.2927508 19.9941977,18.3932117 L20,18.2496563 L20,2.75034375 C20,1.83199 19.2927508,1.07882314 18.3932117,1.00580234 L18.2496563,1 Z M14.664,5 L14.664,6.456 L14.2517778,7.23 C13.5799259,8.52111111 12.984,9.81777778 12.464,11.12 C11.84,12.6826667 11.2986667,14.328 10.84,16.056 L10.84,16.056 L8.808,16.056 L9.06422222,15.2203333 C10.0240741,12.1721111 11.208,9.29866667 12.616,6.6 L12.616,6.6 L7,6.6 L7,5 L14.664,5 Z",
    id: 7,
    fill: "#4C8FB9",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgeRating7, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/age_rating_7.c303d8c9.svg";
export { ForwardRef as ReactComponent };